import { render, staticRenderFns } from "./SubcontractorAdd.vue?vue&type=template&id=0ad50e5a&scoped=true"
import script from "./SubcontractorAdd.vue?vue&type=script&lang=js"
export * from "./SubcontractorAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad50e5a",
  null
  
)

export default component.exports